import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilLimitedActionTime } from "../../utils/utilLimitedActionTime";
import { IconWithProgress } from "../generic/icon-with-progress/IconWithProgress";
import { ResourceRequirement } from "../generic/resource-requirement/ResourceRequirement";
import { TimerCountdownWithText } from "../generic/timer-with-text/TimerCountdownWithText";
import { ButtonDogTreatAddResource } from "./ButtonDogTreatAddResource";
export var DoghouseTreatCountdown = function (_a) {
    var availableFreeTreat = _a.availableFreeTreat, limitedActionInfo = _a.limitedActionInfo, freeTreatIcon = _a.freeTreatIcon, secondsUntilNextTreat = _a.secondsUntilNextTreat;
    var progressPercent = availableFreeTreat.greaterThan(0) ? 100 : 0;
    var freeTreatAvailable = secondsUntilNextTreat <= 0;
    return (React.createElement("div", { className: "dog-treat-invertory-container" },
        React.createElement(IconWithProgress, { icon: freeTreatIcon, iconStyle: IdStyles.IconLarge, fillClassName: IdStyles.ProgressBarFill, backgroundClassName: IdStyles.ProgressBarBackground, progressPercent: progressPercent },
            React.createElement(ResourceRequirement, { available: availableFreeTreat, required: 1 }),
            React.createElement(ButtonDogTreatAddResource, null)),
        !freeTreatAvailable && getFreeInComponent(limitedActionInfo)));
};
var getFreeInComponent = function (limitedActionInfo) {
    var timestamp = utilLimitedActionTime.getResetTimestamp(limitedActionInfo);
    return (React.createElement(TimerCountdownWithText, { locaId: IdLoca.freeInTime, remainingTime: timestamp, className: IdStyles.TextBoldPrimary }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/DoghouseTreatCountdown.tsx
// module id = 2631
// module chunks = 3